import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";
import SchoolIcon from "@mui/icons-material/School";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import { History, Message, Payment, Report, Upload } from "@mui/icons-material";

export const menuItems = [
  {
    title: "Service User",
    path: "/clients",
    icon: PersonIcon,
  },
  {
    title: "Employee",
    path: "/candidates",
    icon: WorkIcon,
    submenu: [
      { title: "Management", path: "/candidates" },
      { title: "Create Employee", path: "/candidate/create" },
      { title: "Temporary Inspector", path: "/employee/temporary-inspector" },
    ],
  },
  {
    title: "Visit",
    path: "/visit-plan",
    icon: SchoolIcon,
    submenu: [
      { title: "Weekly Visit Plans", path: "/visit-plan" },
      { title: "Day2Day Scheduling", path: "/visit-timeline" },
      { title: "Day2Day Card View", path: "/weekly-planner" },
    ],
  },
  { 
    title: "Message",
    path: "/team-chat",
    icon: Message,
    submenu: [
      {title: "Team Chat", path: "/team-chat"},
      {title: "Text Message", path: "/text-message"},
      {title: "Email Message", path: "/email"},
    ]
  },
  { title: "Audit Logs", path: "/audit-logs", icon: History },
  { 
    title: "Dashboard",
    path: "/operation-dashboard",
    icon: DashboardIcon,
    submenu: [
      {title: "Operation Dashboard", path: "/operation-dashboard"},
      {title: "KPI", path: "/kpi"},
      {title: "VOC", path: "/voc"},
    ]
  },
  {
    title: "Finance",
    path: "/finance",
    icon: Payment,
    submenu: [
      { title: "Finance", path: "/finance" },
      { title: "Bank Holiday", path: "/billing/bank-holiday" },
    ]
  },
  {
    title: "Reports",
    path: "/reports",
    icon: Report,
    submenu: [
      { title: "Reports", path: "/reports" },
      { title: "Report Management", path: "/report-managemnt" },
      { title: "Incident Management", path: "/incident-report" },
      { title: "Vaccination Record", path: "/vaccination-record" },
    ]
  },
  {
    title: "Uploads",
    path: "/uploads",
    icon: Upload,
  },
  {
    title: "Settings",
    path: "/settings/reference-data",
    icon: SettingsIcon,
    submenu: [
      { title: "System Settings", path: "/system-settings" },
      { title: "Reference Data", path: "/settings/reference-data" },
      { title: "Care Pathway", path: "/settings/care-pathway" },
      { title: "About Form Builder", path: "/settings/about/forms" },
      { title: "Locations", path: "/settings/location" },
      { title: "Funders & Agencies", path: "/settings/funder-management" },
    ],
  },
];
